import React, { useState, useEffect } from "react";

import {
  ErrorMsg,
  EyeIconSlashedStyled,
  EyeIconStyled,
  InputWrapper,
  InputContainer,
  InputStyled,
  Label,
} from "./styles";

const Input = ({
  label,
  id,
  error,
  autocomplete,
  type,
  showEyeIcon,
  onClickEye,
  mask,
  value,
  setValue,
  onChange,
  ...otherProps
}) => {
  const [inputType, setInputType] = useState(type || 'text')
  const [eyeIsOpen, setEyeIsOpen] = useState(false)
  const [masksFill, setMasksFill] = useState([]);
  useEffect(() => {
    const maskedValue = handleMask(value, mask, masksFill)
    setValue && setValue(maskedValue);
  }, [value]);
  useEffect(() => {
    if(!mask) return;
    const sortedMasks = mask.sort((a, b) => a.length - b.length);
    setMasksFill(sortedMasks.map(mask => mask.split(/\d/)))
  }, []);
  const onClickFn = () => {
    setEyeIsOpen(!eyeIsOpen);
    setInputType(!eyeIsOpen ? 'text' : 'password');
    onClickEye && onClickEye();
  }
  const handleOnChange = (e) => {
    const {value: targetValue} = e.target;
    const maskedValue = handleMask(targetValue, mask, masksFill)
    const event = {...e, target: {value: maskedValue}};
    setValue && setValue(maskedValue);
    onChange && onChange(event);
  }
  return (
    <InputContainer>
      {label && <Label htmlFor={id} data-test="input-label">{label}</Label>}
      <InputWrapper>
        <InputStyled
          id={id}
          type={inputType}
          autoComplete={autocomplete || 'off'}
          data-test="input-component"
          error={error}
          onChange={handleOnChange}
          value={value}
          {...otherProps}
        />
        {showEyeIcon === 1 && <EyeIcon eyeIsOpen={eyeIsOpen} onClickEye={onClickFn}/>}
      </InputWrapper>
      {error && <ErrorMsg data-test="input-error-message">{error}</ErrorMsg>}
    </InputContainer>
  )
}

export default Input;

const EyeIcon = ({eyeIsOpen, onClickEye}) => {
  
  return (
    <>
      {eyeIsOpen ? (
        <EyeIconStyled data-test="input-eye-icon-open" onClick={onClickEye}/>
      ) : (
        <EyeIconSlashedStyled data-test="input-eye-icon-closed" onClick={onClickEye}/>
      )}
    </>
  )
}

const onlyNumbers = (value) => value.replace(/\D/g, '');

const selectMask = (masksFill, value) => {
  const maskFill = masksFill?.find(fill => onlyNumbers(value).length < fill.length);
  const selectedMask = maskFill ? maskFill : masksFill?.[masksFill.length - 1];
  return selectedMask;
}

const handleMask = (newValue, mask, masksFill) => {
  if(!mask){
    return newValue;
  }
  const selectedMask = selectMask(masksFill, newValue);
  const cleanedValue = onlyNumbers(newValue);
  const maskedValue = cleanedValue.split('').reduce((acc, curr, index) => {
    return index < selectedMask.length - 1
    ? `${acc}${selectedMask[index]}${curr}`
    : acc
  },'');
  return maskedValue;
}